var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lottery-container" },
    [
      _c(
        "p",
        { staticClass: "lottery-top" },
        [
          _c("van-icon", {
            staticClass: "goback",
            attrs: { name: "arrow-left", size: "24" },
            on: { click: _vm.goBack }
          }),
          _vm._v("优惠券专区\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "lottery-title" }, [
        _vm._v("\n    每日限量盲盒\n    "),
        _c(
          "span",
          {
            on: {
              click: function($event) {
                _vm.ruleShow = true
              }
            }
          },
          [_vm._v("活动规则")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lottery-tool" }, [
        _c("p", { staticClass: "blind-box" }, [
          _vm._v("今日仅剩" + _vm._s(_vm.status.inventory) + "个盲盒")
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "lottery-machine",
          attrs: { src: require("../../../static/images/machine.png") }
        }),
        _vm._v(" "),
        _vm.status.isJoin == 1
          ? _c("div", { staticClass: "lottery-btn" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.status.isJoin == 1
                ? _c("img", {
                    attrs: {
                      src: require("../../../static/images/open_lottery.png")
                    },
                    on: { click: _vm.lotteryGet }
                  })
                : _vm._e()
            ])
          : _c("div", { staticClass: "lottery-btn" }, [
              _vm.status.isJoin == 2
                ? _c("p", { staticClass: "tip" }, [
                    _c("span"),
                    _vm._v("今日次数已用完 明日再来\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status.isJoin == 2 || _vm.status.inventory == 0
                ? _c("img", {
                    attrs: {
                      src: require("../../../static/images/close_lottery.png")
                    }
                  })
                : _vm._e()
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "my-prize" }, [
        _c("p", { staticClass: "lottery-extract" }, [
          _vm._v("\n      盲盒领取说明\n      "),
          _c("span", { on: { click: _vm.getPrize } }, [_vm._v("已获奖品")])
        ]),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _vm.isloading
        ? _c("div", { staticClass: "lottery-loading" }, [_vm._m(2)])
        : _vm._e(),
      _vm._v(" "),
      _vm.isWin
        ? _c("div", { staticClass: "lottery-loading" }, [
            _c("div", { staticClass: "win-prize" }, [
              _c("img", {
                staticClass: "prize-border",
                attrs: {
                  src: require("../../../static/images/coupon_border.png")
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "close",
                attrs: {
                  src: require("../../../static/images/lottery_shut.png")
                },
                on: {
                  click: function($event) {
                    _vm.isWin = false
                  }
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "prize-title" }, [
                _vm._v("恭喜开出以下奖品")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "getprize-content" }, [
                _c("img", { attrs: { src: _vm.getLottery[0].img } }),
                _vm._v(" "),
                _c("div", { staticClass: "getprize-detail" }, [
                  _c("p", { staticClass: "getprize-name" }, [
                    _vm._v(_vm._s(_vm.getLottery[0].name))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "getprize-desc" }, [
                    _vm._v(_vm._s(_vm.getLottery[0].desc))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "use",
                  on: {
                    click: function($event) {
                      return _vm.useCoupon(
                        _vm.getLottery[0],
                        _vm.getLottery[0].id
                      )
                    }
                  }
                },
                [_vm._v("去使用")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.noPrize
        ? _c("div", { staticClass: "lottery-loading" }, [
            _c("div", { staticClass: "no-prize" }, [
              _c("img", {
                staticClass: "close",
                attrs: {
                  src: require("../../../static/images/lottery_close.png")
                },
                on: {
                  click: function($event) {
                    _vm.noPrize = false
                  }
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "prize-title" }, [_vm._v("未抽到奖品")]),
              _vm._v(" "),
              _vm._m(3)
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "rule-popup",
          attrs: { closeable: "" },
          model: {
            value: _vm.ruleShow,
            callback: function($$v) {
              _vm.ruleShow = $$v
            },
            expression: "ruleShow"
          }
        },
        [
          _c("p", { staticClass: "rule-title" }, [_vm._v("活动规则")]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("1")]),
            _vm._v("优惠券盲盒每日限量抽取，先到先得；\n    ")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("2")]),
            _vm._v("每人每天仅有1次开盲盒机会；\n    ")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("3")]),
            _vm._v(
              "每个盲盒中包含不同金额的优惠券，优惠券之间不可叠加使用，使用门槛详见各优惠券使用规则；\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("4")]),
            _vm._v("优惠券仅限在中公网校APP购买商品使用；\n    ")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("span", [_vm._v("5")]),
            _vm._v("本活动最终解释权归中公网校所有。\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "prize-popup",
          attrs: { closeable: "" },
          model: {
            value: _vm.prizeShow,
            callback: function($$v) {
              _vm.prizeShow = $$v
            },
            expression: "prizeShow"
          }
        },
        [
          _c("p", { staticClass: "rule-title" }, [_vm._v("已获奖品")]),
          _vm._v(" "),
          _vm.list && _vm.list.length
            ? _c(
                "div",
                _vm._l(_vm.list, function(i, index) {
                  return _c("div", { key: index, staticClass: "prize-list" }, [
                    _c("div", { staticClass: "prize-content" }, [
                      _c("img", { attrs: { src: i.img } }),
                      _vm._v(" "),
                      _c("div", { staticClass: "prize-detail" }, [
                        _c("p", { staticClass: "prize-name" }, [
                          _vm._v(_vm._s(i.name))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "prize-desc" }, [
                          _vm._v(_vm._s(i.desc))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "use-coupon",
                          on: {
                            click: function($event) {
                              return _vm.useCoupon(i, i.id)
                            }
                          }
                        },
                        [_vm._v("去使用")]
                      )
                    ])
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "empty-list" }, [
                _c("img", {
                  attrs: { src: require("../../../static/images/empty.png") }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("暂未获得奖品，赶紧去抽奖吧～")])
              ])
        ]
      ),
      _vm._v(" "),
      _vm.show
        ? _c("div", { staticClass: "goods_wrapper" }, [
            _c(
              "div",
              { staticClass: "goods_box" },
              [
                _c("img", {
                  staticClass: "closeList",
                  attrs: { src: require("../../../static/images/guanbi.png") },
                  on: { click: _vm.closeList }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "goods_title" }, [_vm._v("商品列表")]),
                _vm._v(" "),
                _c(
                  "van-list",
                  {
                    attrs: {
                      finished: _vm.finished,
                      "finished-text": "没有更多了",
                      "immediate-check": false
                    },
                    on: { load: _vm.onLoad },
                    model: {
                      value: _vm.loading,
                      callback: function($$v) {
                        _vm.loading = $$v
                      },
                      expression: "loading"
                    }
                  },
                  _vm._l(_vm.goodsList, function(item, index) {
                    return _c("van-cell", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "goods_list",
                          on: {
                            click: function($event) {
                              return _vm.goShop(item.url)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "goods_content" }, [
                            _c("img", {
                              attrs: { src: "//s.eoffcn.com/" + item.img }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "goods_detail" }, [
                              _c("p", { staticClass: "goods_name" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "goods_price" }, [
                                _vm._v(
                                  "\n                  ¥\n                  "
                                ),
                                item.minPrice
                                  ? _c("span", [
                                      _vm._v(_vm._s(item.minPrice / 100) + " -")
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.maxPrice / 100) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "tip" }, [
      _c("span"),
      _vm._v("今日还有1次机会\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "coupon-prize" }, [
      _c("img", { attrs: { src: require("../../../static/images/10.png") } }),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../../static/images/20.png") } }),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../../static/images/50.png") } }),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../../static/images/100.png") } }),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../../static/images/200.png") } }),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../../../static/images/1000.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lottery-box" }, [
      _c("img", { attrs: { src: require("../../../static/images/gift.gif") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noprize-content" }, [
      _c("img", {
        attrs: { src: require("../../../static/images/noprize.png") }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("奖品已经被抽光了，下次早点来吧～")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9a08ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9a08ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lottery/index.vue
// module id = null
// module chunks = 